import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import SvgX from "../../../svg/SvgX";
import SvgArrowL from "../../../svg/SvgArrowL";
import { db, deleteDocumentFirebase, updateDocumentFirebase } from "../../../../services/data-firebase";
import { FaWhatsapp, FaHome, FaMoneyBillWave, FaClock, FaCreditCard, FaUser, FaChild, FaEnvelope, FaCheck, FaTimes } from "react-icons/fa"; // Importar íconos de react-icons/fa
import { CiNoWaitingSign } from "react-icons/ci";
import { GiConfirmed } from "react-icons/gi";
import ConfirmAlert from "../../../alertComponent/ConfirmAlert";
import { LuCalendarDays } from "react-icons/lu";
import { useUser } from "../../../../context/UserContext";
import { collection, onSnapshot, query, where } from "firebase/firestore";

export default function ModalMembre({ serviceSub, fetchData }) {
    const { user } = useUser();

    const [isModalOpen, setIsModalOpen] = useState(false); // Estado para controlar el modal
    const [selectedService, setSelectedService] = useState(null); // Estado para almacenar el servicio seleccionado
    const [hasNewServices, setHasNewServices] = useState(false); // Estado para notificación

    const [servicesSub, setServicesSub] = useState([]); // Estado para almacenar los servicios de membresía

    const nameCollectionFromFirebaseInUserMembre = 'match-subs'; // Nombre de la colección en Firestore
    const [isAlertOpen, setIsAlertOpen] = useState(false);

    // Escuchar actualizaciones en tiempo real de la colección "match-subs"
    useEffect(() => {
        if (!user?.idFirestore) return; // Asegúrate de que el usuario esté definido

        // Crear una consulta para filtrar por idNana
        const q = query(
            collection(db, "match-subs"),
            where("idNana", "==", user.idFirestore)
        );

        // Escuchar los cambios en tiempo real
        const unsubscribe = onSnapshot(q, (snapshot) => {
            const updatedServices = snapshot.docs.map((doc) => ({
                idFirestore: doc.id,
                ...doc.data(),
            }));
            setServicesSub(updatedServices); // Actualizar el estado con los datos actualizados

            // Verificar si hay nuevos servicios
            const hasNew = updatedServices.some((service) => !service.state);
            setHasNewServices(hasNew);
        });

        // Limpiar la suscripción cuando el componente se desmonte
        return () => unsubscribe();
    }, [user?.idFirestore]);

    console.log(servicesSub, 'daos escuchados');

    // Función para abrir el modal
    const openModal = () => setIsModalOpen(true);

    // Función para cerrar el modal
    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedService(null); // Limpiar el servicio seleccionado al cerrar el modal
    };

    // Función para manejar el clic en un servicio
    const handleServiceClick = (service) => {
        setSelectedService(service);
    };

    // Función para manejar la aceptación del servicio
    const handleAcceptService = async () => {
        if (!selectedService) return; // Asegurarse de que hay un servicio seleccionado

        try {
            // Actualizar el campo "state" a true en Firestore
            await updateDocumentFirebase(
                nameCollectionFromFirebaseInUserMembre, // Nombre de la colección
                selectedService.idFirestore, // ID del documento
                { state: true } // Datos a actualizar
            );
            fetchData(); // Llamar a fetchData después de aceptar
            closeModal(); // Cerrar el modal después de aceptar
        } catch (error) {
            console.error("Error al aceptar el servicio:", error);
        }
    };

    // Función para manejar el rechazo del servicio
    const handleRejectService = () => {
        setIsAlertOpen(true); // Mostrar el alert de confirmación
    };

    // Función para manejar el elimar el servicio aceptado

    const hanldeDeletServiceConfirmate = () => {
        setIsAlertOpen(true); // Mostrar el alert de confirmación
    }

    const handleConfirm = async (confirmed) => {
        if (confirmed) {
            // Si el usuario confirma, ejecutar la lógica de rechazo
            try {
                await deleteDocumentFirebase(
                    nameCollectionFromFirebaseInUserMembre,
                    selectedService.idFirestore
                );
                fetchData(); // Llamar a fetchData después de eliminar
                closeModal(); // Cerrar el modal
            } catch (error) {
                console.error("Error al rechazar el servicio:", error);
            }
        }
        setIsAlertOpen(false); // Cerrar el alert
    };

    // Función para formatear el número de teléfono y agregar un mensaje automático
    const formatWhatsAppLink = (phone, message) => {
        if (!phone) return "";

        // Formatear el número de teléfono
        const cleaned = phone.replace(/[\s\-()]/g, "");
        const formattedPhone = cleaned.startsWith("+") ? cleaned : `${cleaned}`;

        // Codificar el mensaje para que sea válido en una URL
        const encodedMessage = encodeURIComponent(message);

        // Retornar el enlace completo
        return `https://wa.me/${formattedPhone}?text=${encodedMessage}`;
    }

    // Función para formatear la fecha a partir de nanoseconds y seconds
    const formatDate = (timestamp) => {
        if (!timestamp) return "Fecha no disponible";
        const date = new Date(timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000);
        return date.toLocaleDateString(); // Formato legible (puedes personalizarlo)
    };

    // Mensaje automático
    const automaticMessage = selectedService
        ? `Hola ${selectedService?.padres.name}, soy ${selectedService?.nana.name}, la niñera asignada para el servicio. Me gustaría coordinar los detalles del servicio. ¿Podemos hablar?`
        : "";

    return (
        <div className="px-4 text-gray-600 ml-4 py-2 flex flex-row rounded-lg bg-[#e896ef] text items-center">
            {/* Botón para abrir el modal */}
            <button onClick={openModal} className="text-white flex items-center gap-2 relative">
                Servicios de miembros
                {hasNewServices && (
                    <span className=" top-0 right-0  bg-red-500 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center">
                        !
                    </span>
                )}
            </button>

            {/* Modal */}
            <AnimatePresence>
                {isModalOpen && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center "
                        onClick={closeModal} // Cerrar modal al hacer clic fuera
                    >
                        <motion.div
                            initial={{ y: -50, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            exit={{ y: -50, opacity: 0 }}
                            className="bg-white overflow-y-auto rounded-lg p-4 w-full max-w-screen-md max-h-[calc(100vh-4rem)]"
                            onClick={(e) => e.stopPropagation()} // Evitar que el modal se cierre al hacer clic dentro
                        >
                            {/* Encabezado del modal */}
                            <div className="flex justify-between items-center mb-4">
                                <h2 className="text-xl font-bold">Servicios</h2>
                                <button
                                    onClick={closeModal}
                                    className="text-white bg-red-600 rounded-md hover:text-gray-700"
                                >
                                    <SvgX />
                                </button>
                            </div>

                            {serviceSub.length === 0 ? 'No hay servicios' : ''}
                            {!selectedService ? (
                                <div className="space-y-4">
                                    {serviceSub?.map((service) => (
                                        <motion.div
                                            key={service.idFirestore}
                                            whileHover={{ scale: 0.96 }}
                                            whileTap={{ scale: 0.95 }}
                                            className={`p-4 rounded-lg cursor-pointer border-l-4 ${
                                                service.state
                                                    ? 'bg-[#ecb0f18f] border-[#e896ef]'
                                                    : 'bg-gray-200 border-gray-700'
                                            }`}
                                            onClick={() => handleServiceClick(service)}
                                        >
                                            <h3 className="font-semibold flex items-center gap-2">
                                                <FaHome className="text-blue-500" /> Barrio: {service.padres.neighborhood}
                                            </h3>
                                            <h3 className="font-semibold flex items-center gap-2">
                                                <FaHome className="text-blue-500" />  {service.padres.address}
                                            </h3>

                                            <h3 className="font-semibold flex items-center gap-2">
                                                <LuCalendarDays className="text-pink-500" />
                                                Días: {service.diasServicio?.join(", ") || "No especificado"} {/* Mostrar los días o un mensaje predeterminado */}
                                            </h3>
                                            <h3 className="font-semibold flex items-center gap-2">
                                                <FaClock className="text-purple-500" /> Horario: {service.tipoHorario}
                                            </h3>
                                            <h3 className="font-semibold flex items-center gap-2">
                                                <FaMoneyBillWave className="text-green-500" /> Propuesta: ${service.propuestaEconomica}
                                            </h3>
                                            <h3 className="font-semibold flex items-center gap-2">
                                                <FaCreditCard className="text-yellow-500" /> Tipo de Pago: {service.tipoPago}
                                            </h3>
                                            <h3 className="font-semibold flex items-center gap-2">
                                                <FaUser className="text-pink-500" /> Contratación: Por {service.tipoContratacion}
                                            </h3>

                                            <br />
                                            <h3 className="font-semibold flex items-center gap-2">
                                                {service.state ? <GiConfirmed /> : <CiNoWaitingSign className="text-pink-500" />} Estado: {service.state ? 'Aceptado' : 'En Espera'}
                                            </h3>
                                        </motion.div>
                                    ))}
                                </div>
                            ) : (
                                <>
                                    {/* Detalle del servicio (DetailCard) */}
                                    <motion.div
                                        initial={{ x: 50, opacity: 0 }}
                                        animate={{ x: 0, opacity: 1 }}
                                        exit={{ x: 50, opacity: 0 }}
                                        className="space-y-4 max-h-[85vh] custom-scrollbar"
                                    >
                                        <button onClick={() => setSelectedService(null)}>
                                            <SvgArrowL />
                                        </button>
                                        <h3 className="text-xl font-bold">Detalles del Servicio</h3>

                                        {/* Sección: Lugar */}
                                        <div className="border-b pb-4 mb-4">
                                            <h4 className="text-lg font-semibold">Lugar</h4>
                                            <p className="flex items-center gap-2">
                                                <FaHome className="text-blue-500" /> <strong>Barrio:</strong> {selectedService.padres.neighborhood}
                                            </p>
                                            <p className="flex items-center gap-2">
                                                <FaHome className="text-blue-500" /> <strong>Dirección:</strong> {selectedService.padres.address}
                                            </p>
                                        </div>

                                        {/* Sección: Detalle del Servicio */}
                                        <div className="border-b pb-4 mb-4">
                                            <h4 className="text-lg font-semibold">Detalle del Servicio</h4>
                                            <p className="flex items-center gap-2">
                                                <LuCalendarDays className="text-pink-500" /> <strong>Días:</strong> {selectedService.diasServicio?.join(", ") || "No especificado"}
                                            </p>
                                            <p className="flex items-center gap-2">
                                                <FaClock className="text-purple-500" /> <strong>Horario:</strong> {selectedService.tipoHorario}
                                            </p>
                                            <p className="flex items-center gap-2">
                                                <FaMoneyBillWave className="text-green-500" /> <strong>Propuesta:</strong> ${selectedService.propuestaEconomica}
                                            </p>
                                            <p className="flex items-center gap-2">
                                                <FaCreditCard className="text-yellow-500" /> <strong>Tipo de Pago:</strong> {selectedService.tipoPago}
                                            </p>
                                            <p className="flex items-center gap-2">
                                                <FaUser className="text-pink-500" /> <strong>Contratación:</strong> Por {selectedService.tipoContratacion}
                                            </p>
                                        </div>

                                        {/* Sección: Información del Usuario */}
                                        <div>
                                            <h4 className="text-lg font-semibold">Información del Usuario</h4>
                                            <p className="flex items-center gap-2">
                                                <FaUser className="text-pink-500" /> <strong>Nombre del Padre:</strong> {selectedService.padres.name}
                                            </p>
                                            <p className="flex items-center gap-2">
                                                <FaClock className="text-purple-500" /> <strong>Fecha de Creación:</strong> {formatDate(selectedService.padres.createdAt)}
                                            </p>
                                            <p className="flex items-center gap-2">
                                                <FaWhatsapp className="text-green-500" /> <strong>Teléfono:</strong>{" "}
                                                <a
                                                    href={formatWhatsAppLink(selectedService.padres.phone, automaticMessage)}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-blue-500 hover:text-blue-700"
                                                >
                                                    {selectedService.padres.phone}
                                                </a>
                                            </p>
                                            <p className="flex items-center gap-2">
                                                <a
                                                    href={`mailto:${selectedService.padres.email}`}
                                                    className="flex items-center gap-2 hover:text-blue-500 transition-colors"
                                                >
                                                    <FaEnvelope className="text-red-500 w-4 h-4" />
                                                    <strong>Email:</strong> {selectedService.padres.email}
                                                </a>
                                            </p>
                                            <p className="flex items-center gap-2">
                                                <FaChild className="text-green-500" /> <strong>Detalles:</strong>
                                            </p>
                                            <div className="max-h-24 overflow-y-auto p-2 border rounded-md custom-scrollbar">
                                                {selectedService.detallesNinos}
                                            </div>
                                        </div>

                                        {/* Botones para aceptar o rechazar el servicio */}
                                        <div className="flex justify-between mt-4">
                                            {selectedService?.state ? (
                                                <button
                                                    onClick={hanldeDeletServiceConfirmate}
                                                    className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600 flex items-center mx-auto"
                                                >
                                                    <FaTimes /> Eliminar Servicio
                                                </button>
                                            ) : (
                                                <>
                                                    <button
                                                        onClick={handleAcceptService}
                                                        className="bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600 flex items-center gap-2"
                                                    >
                                                        <FaCheck /> Aceptar Servicio
                                                    </button>
                                                    <button
                                                        onClick={handleRejectService}
                                                        className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600 flex items-center gap-2"
                                                    >
                                                        <FaTimes /> Rechazar Servicio
                                                    </button>
                                                </>
                                            )}
                                        </div>

                                        {/* Alert de confirmación */}
                                        <ConfirmAlert
                                            isOpen={isAlertOpen}
                                            onClose={() => setIsAlertOpen(false)}
                                            onConfirm={handleConfirm}
                                            message="¿Estás seguro de realizar esta acción?"
                                        />
                                    </motion.div>
                                </>
                            )}
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
}